import {DestroyFilterDrawerAction, ShowFilterDrawerAction} from "../../interfaces/store/actions/filter";
import {DESTROY_FILTER_DRAWER, SHOW_FILTER_DRAWER} from "./availableActions";

export const showFilterDrawer = (): ShowFilterDrawerAction => ({
    type: SHOW_FILTER_DRAWER,
});

export const destroyFilterDrawer = (): DestroyFilterDrawerAction => ({
    type: DESTROY_FILTER_DRAWER,
});
